import { Redirect } from 'react-router-dom'

//Dashboard
import Dashboard from '../pages/Dashboard'

// onboarding KYC
import kycPage from '../pages/KYC/kyc'

// payouts and accounts
import addPayoutPage from '../pages/Payouts/add-payout'
import ExternalAccountsPage from '../pages/Payouts/external-accounts'

import setupMerchantPage from '../pages/Merchant/setup-merchant'
import merchantPage from '../pages/Merchant/merchant'

// offers
import OffersPage from '../pages/offers/offers.page'
import OfferPage from '../pages/offer/offer.page'

// open banking
import ExternalAccountOpenBankingVRPsPage from '../pages/ExternalAccountOpenBankingVRPs/external-account-open-banking-vrps.page'
import OpenBankingObieRedirectPage from '../pages/OpenBankingRedirect/obie/open-banking-obie-redirect.page'

// transactions
import transactionsPage from '../pages/Transactions/transactions'

// payment requests
import paymentRequestsPage from '../pages/PaymentRequests/payment-requests'

// pay points
import payPointsPage from '../pages/PayPoints/pay-points'

// Card Details
import CardDetailsPage from 'src/pages/CardDetails/card-details.page'

//Authentication pages
import Login from 'src/pages/Authentication/Login'
import Logout from 'src/pages/Authentication/Logout'
import Register from 'src/pages/Authentication/Register'
import userProfile from 'src/pages/Authentication/user-profile'

import LoginSupport from '../pages/Authentication/Login-Support'
import TerminalShippingPage from '../pages/TerminalShipping/terminal-shipping'
import RegisteredMerchantsPage from '../pages/RegisteredMerchants/RegisteredMerchantsPage'
import XeroMerchant from '../pages/Authentication/XeroMerchant'
import XeroConnected from '../pages/Authentication/XeroConnected'
import AppBuildsPage from '../pages/AppBuilds/AppBuildsPage'
import DiscountCodesPage from '../pages/DiscountCodes/discount-codes'
import FraudRulesPage from '../pages/FraudPrevention/FraudRulesPage'
import WaitingListsPage from 'src/pages/WaitingLists/waiting-lists.page'
import WaitingListMerchants from 'src/pages/WaitingListMerchants/waiting-list-merchants.page'
import QuickbooksPage from 'src/pages/Quickbooks/quickbooks.page'
import QuickBooksDisconnectedPage from 'src/pages/Quickbooks/quickbooks-disconnected.page'
import XeroSignup from 'src/pages/Authentication/XeroSignup'
import MarketingDeepLinksPage from 'src/pages/MarketingDeepLinks/marketing-deep-links.page'
import HardwarePage from 'src/pages/Hardware/hardware.page'
import KYBThresholdsPage from 'src/pages/FraudPrevention/KYBThresholdsPage'
import UsersPage from 'src/pages/Users/UsersPage'
import HardwarePricingPage from 'src/pages/Hardware/HardwarePricing/hardware-pricing.page'

interface RouteProps {
  path: string
  component: any
  exact?: boolean
}

const userRoutes: Array<RouteProps> = [
  //User Profile
  { path: '/profile', component: userProfile },

  //kyc onboarding
  { path: '/kyc', component: kycPage },
  { path: '/setup-merchant', component: setupMerchantPage },

  { path: '/add-external-account', component: addPayoutPage },
  { path: '/external-accounts', component: ExternalAccountsPage },

  // offers
  { path: '/offers', component: OffersPage },
  { path: '/offers/:offerId', component: OfferPage },

  // merchant
  { path: '/merchant/:merchantId', component: merchantPage },

  { path: '/terminal-shipping', component: TerminalShippingPage },

  { path: '/registered-merchants', component: RegisteredMerchantsPage },
  { path: '/users', component: UsersPage },

  // Managing fraud prevention rules
  { path: '/fraud-prevention/fraud-rules', component: FraudRulesPage },
  { path: '/fraud-prevention/kyb-thresholds', component: KYBThresholdsPage },

  // Managing testing of app builds
  { path: '/app-builds', component: AppBuildsPage },

  // Manage discount codes (for marketing purposes)
  { path: '/discount-codes', component: DiscountCodesPage },

  // open banking
  {
    path: '/external-accounts/open-banking-vrps',
    component: ExternalAccountOpenBankingVRPsPage,
  },
  {
    path: '/open-banking/oauth/redirect/obie',
    component: OpenBankingObieRedirectPage,
  },

  // transactions
  { path: '/transactions', component: transactionsPage },

  // paymentRequestsPage
  { path: '/payment-links', component: paymentRequestsPage },

  { path: '/marketing-deep-links', component: MarketingDeepLinksPage },

  // paymentRequestsPage
  { path: '/pay-points', component: payPointsPage },

  // Waiting lists page
  { path: '/waiting-lists', component: WaitingListsPage },
  { path: '/waiting-lists/:id', component: WaitingListMerchants },

  // Hardware
  { path: '/hardware', component: HardwarePage },
  { path: '/hardware/pricing', component: HardwarePricingPage },

  //dashboard
  { path: '/dashboard', component: Dashboard },

  // this route should be at the end of all other routes
  { path: '/', exact: true, component: () => <Redirect to="/dashboard" /> },
]

const authRoutes: Array<RouteProps> = [
  //Authentication pages
  { path: '/login-support', component: LoginSupport },
  { path: '/login', component: Login },
  { path: '/logout', component: Logout },
  { path: '/register', component: Register },

  { path: '/register-xero', component: XeroSignup },

  { path: '/xero/:merchantId/:apiKey?', component: XeroMerchant },
  { path: '/xero-connect', component: XeroConnected },

  { path: '/quickbooks', component: QuickbooksPage },
  { path: '/quickbooks/disconnected', component: QuickBooksDisconnectedPage },

  // Lopay Rewards Card Details
  { path: '/card-details', component: CardDetailsPage },
]

export { userRoutes, authRoutes }
